import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService, AuthService } from '@homeleite/arch';
import { LoginResult, LoginValidator } from '@homeleite/common-pages';
import { TenantsRepository } from '@homeleite/domain';
import { BaseLoginService } from '../../../../../../libs/domain/src/lib/login/base-login.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class LoginService extends BaseLoginService implements LoginValidator {
    constructor(
        api: ApiService,
        tenantsRepository: TenantsRepository,
        router: Router,
        authService: AuthService,
        snackbar: MatSnackBar
    ) {
        super(api, tenantsRepository, router, authService, snackbar);
    }

    async validateLogin(username: string, pw: string): Promise<LoginResult> {
        if (!username || username?.length < 3) {
            return LoginResult.fail('Usuário precisa ter mais de 3 caracteres');
        }
        if (!pw || pw?.length < 3) {
            return LoginResult.fail('Preencha uma senha com mais de 3 caracteres');
        }
        try {
            const result = await this.fetchToken(username, pw);
            return this.handleToken(result.token);
        } catch (err) {
            return LoginResult.fail();
        }
    }
}
